import React from "react";
import { FileText, Shield, Globe, Bell } from 'lucide-react';

export default function SimplifiedProcessFlow() {
  const handleGetStartedClick = () => {
    const event = new CustomEvent('toggleDemo');
    window.dispatchEvent(event);

    document.getElementById('hero').scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <div className="">
      <div className="items-center max-w-screen-xl px-4 py-8 mx-auto lg:grid lg:grid-cols-4 lg:gap-16 xl:gap-24 lg:py-24 lg:px-6">
        <div className="col-span-2 mb-8">
          <p className="text-lg font-semibold text-indigo-600 dark:text-indigo-600">
            How Cross Intelligence Works
          </p>
          <h2 className="mt-3 mb-4 text-2xl font-bold tracking-tight text-gray-900 md:text-3xl dark:text-white">
            Simplifying Cross-Border Compliance with GenAI
          </h2>
          <p className="font-normal text-gray-500 sm:text-lg dark:text-gray-400">
            A streamlined, GenAI-powered solution for sellers to navigate global regulations and government incentives effortlessly.
          </p>
          <div className="pt-6 mt-6 space-y-4 border-t border-gray-200 dark:border-gray-700">
            <div>
              <a
                href="#"
                onClick={handleGetStartedClick}
                className="inline-flex items-center text-base font-medium text-indigo-600 hover:text-purple-800 dark:text-indigo-600 dark:hover:text-purple-700"
              >
                Get Started
              </a>
            </div>
          </div>
        </div>
        <div className="col-span-2 space-y-8 md:grid md:grid-cols-2 md:gap-12 md:space-y-0">
          <div>
            <FileText className="w-10 h-10 mb-2 text-indigo-600 md:w-12 md:h-12 dark:text-indigo-600" />
            <h3 className="mb-2 text-xl font-semibold dark:text-white">
              Automated Document Generation
            </h3>
            <p className="font-normal text-gray-500 dark:text-gray-400">
              Instantly create accurate compliance documents for cross-border transactions.
            </p>
          </div>
          <div>
            <Shield className="w-10 h-10 mb-2 text-indigo-600 md:w-12 md:h-12 dark:text-indigo-600" />
            <h3 className="mb-2 text-xl font-semibold dark:text-white">
              Real-Time Compliance Tracking
            </h3>
            <p className="font-normal text-gray-500 dark:text-gray-400">
              Stay updated on regulatory changes and maintain compliance effortlessly.
            </p>
          </div>
          <div>
            <Globe className="w-10 h-10 mb-2 text-indigo-600 md:w-12 md:h-12 dark:text-indigo-600" />
            <h3 className="mb-2 text-xl font-semibold dark:text-white">
              Multilingual and Multimodal Support
            </h3>
            <p className="font-normal text-gray-500 dark:text-gray-400">
              Access guidance in multiple languages and formats for broader reach.
            </p>
          </div>
          <div>
            <Bell className="w-10 h-10 mb-2 text-indigo-600 md:w-12 md:h-12 dark:text-indigo-600" />
            <h3 className="mb-2 text-xl font-semibold dark:text-white">
              Incentives and Subsidy Alerts
            </h3>
            <p className="font-normal text-gray-500 dark:text-gray-400">
              Get notified of relevant incentives and subsidies to reduce costs.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}